<template>
  <div
    class="bg-action-default-hi mood-tangaroa rounded-lg flex flex-col p-16 md:flex-row md:items-start md:p-24"
    data-test="app-download-banner"
  >
    <div
      class="hidden justify-center px-24 align-middle md:flex md:w-1/3 md:justify-end"
    >
      <div
        class="bg-static-default-min rounded-lg flex h-160 self-center overflow-hidden"
      >
        <RevIllustration
          alt="QR Code"
          :height="160"
          sizes="160px"
          src="/img/lead-collection/QR-code.svg"
          :width="160"
        />
      </div>
    </div>

    <div class="w-full md:max-w-[32vw]">
      <h2 class="heading-1">{{ title }}</h2>
      <p class="mb-12">{{ description }}</p>

      <StoreButtons :class="buttonClasses" :trackingZone @click="handleClick" />

      <Dropdown
        v-if="hasTerms"
        :description="termsDescription"
        :title="termsTitle"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { RevIllustration } from '@ds/components/Illustration'

import Dropdown from '../Dropdown/Dropdown.vue'

import StoreButtons from './AppStoreButtons/AppStoreButtons.vue'

const emit = defineEmits(['actioned'])

const props = withDefaults(
  defineProps<{
    title: string
    description: string

    termsTitle?: string
    termsDescription?: string

    trackingZone: string
  }>(),
  {
    termsTitle: '',
    termsDescription: '',
  },
)

const hasTerms = computed(() => {
  return !!(props.termsTitle && props.termsDescription)
})

const buttonClasses = computed(() => {
  return hasTerms.value ? 'mb-12' : 'mb-0'
})

function handleClick() {
  emit('actioned')
}
</script>
